import { compose, withProps } from 'recompose'
import ProductItem from './ProductItem'
import { getFreeAlignmentCheckBlockState } from 'components/MyGarage2.0/helpers'

const withFreeAlignmentProps = withProps(({ freeAligmentTooltip, services }) => ({
  freeAlignmentCheckDisabled: !freeAligmentTooltip.commerceItemId || getFreeAlignmentCheckBlockState(services)
}))

export default compose(
  withFreeAlignmentProps
)(ProductItem)
